import React, { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Accounts_Verify, Accounts_Reverify } from '../api/API_Accounts';
import DRLogo from '../Assets/Images/DR_Logo.png';
import REDLogo from '../Assets/Images/RED_Logo.png';
import Background from '../Assets/Images/NSDAPS_Main_Facade.png';
import FormLandingLogin from '../components/LoginRegister/Form_Landing_LogIn';
import FormLandingRegister from '../components/LoginRegister/Form_Landing_Register';
// import Test_Rooms_List from '../components/Test_Rooms_List';
import UISubwindows from '../components/UI_Subwindows';
import UI_Subwindow_Manager from '../components/ERUMAUI/UI_Subwindow_Manager';
import { Context_UI } from '../Contexts/Context_UI';
import Subwindow_Modal_Register_Verified from '../components/Subwindow_Modal_Register_Verified';



export default function Rooms_Page() {
    const UI = useContext(Context_UI);
    const [Loading, Loading_Set] = useState(false);
    const [Verify_State_Message, Verify_State_Message_Set] = useState("Inactive");
    const [Verify_State, Verify_State_Set] = useState("Inactive");
    const Navigate = useNavigate();

    useEffect(() => {
        UI.Page_Navigator_Set(Navigate);
        setTimeout(function () {
            // window.Initial_Properties_Set();
            window.LoadingScreen_Hide();
        }, 2000);
    }, []);

    const [Composition_Subwindow, Composition_Subwindow_Set] = useState([
        {
            ID: "Window_Register_Verified",
            Component: <Subwindow_Modal_Register_Verified />
        }
    ]);

    const Location = useLocation();
    const Parameters = new URLSearchParams(Location.search);
    const Verify_Token = Parameters.get('vt');

    const hasVerified = useRef(false);

    useEffect(() => {
        // if (!Verify_Token || hasVerified.current) {
        //     Navigate("/");
        // };

        hasVerified.current = true;

        Verify_State_Set("Verifying");
        Verify_State_Message_Set("Active");

        Accounts_Verify({ Token: Verify_Token })
            .then((res) => {
                // console.log(res.data.message);
                if (res.status === 200) {
                    Verify_State_Set("Success");
                    Verify_State_Message_Set("Verified");
                    UI.Subwindows_Open("Window_Register_Verified");
                }
            })
            .catch((err) => {
                // console.log(err.response?.data?.code);
                let Error = err.response?.data?.code;
                switch (Error) {
                    case "NOTOKEN":
                        Verify_State_Set("Token_Nothing");
                        break;
                    case "INVALIDTOKEN":
                        Verify_State_Set("Token_Invalid");
                        break;
                    case "ALRVERIFIED":
                        Verify_State_Set("Token_Irrelevant");
                        break;
                    case "EXPIRED":
                        Verify_State_Set("Token_Expired");
                        break;
                    case "ERROR":
                        Verify_State_Set("Error");
                        break;
                }
                // Verify_State_Set("Error");
                Verify_State_Message_Set(err.response?.data?.message || "Inactive");
            });
    }, [Verify_Token]);

    const Resend = () => {
        Verify_State_Set("Verifying");
        Verify_State_Message_Set("Active");
        Accounts_Reverify({ Token: Verify_Token })
            .then((res) => {
                // console.log(res.data.message);
                if (res.status === 200) {
                    Verify_State_Set("Reverify_Sent");
                    Verify_State_Message_Set("Verified");
                }
            })
            .catch((err) => {
                // console.log(err.response?.data?.code);
                let Error = err.response?.data?.code;
                switch (Error) {
                    case "NOTOKEN":
                        Verify_State_Set("Token_Nothing");
                        break;
                    case "INVALIDTOKEN":
                        Verify_State_Set("Token_Invalid");
                        break;
                    case "ALRVERIFIED":
                        Verify_State_Set("Token_Irrelevant");
                        break;
                    case "EXPIRED":
                        Verify_State_Set("Token_Expired");
                        break;
                    case "ERROR":
                        Verify_State_Set("Error");
                        break;
                }
                // Verify_State_Set("Error");
                Verify_State_Message_Set(err.response?.data?.message || "Inactive");
            });
    }

    return (
        <>
            <UI_Subwindow_Manager Composition={Composition_Subwindow} />
            <div className="Landing">
                <div className="Landing_Content">
                    <div className="Landing_Logo_DR">
                        <img className="Landing_Logo_DR_Image" src={DRLogo} draggable="false" loading='lazy' alt='' />
                        <p>{Loading}</p>
                    </div>

                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div className='Landing_Verify'>
                            <h2 className='General_Title'>
                                {Verify_State === "Token_Nothing" ?
                                    "Verification failed"
                                    :
                                    Verify_State === "Token_Invalid" ?
                                        "Verification invalid"
                                        :
                                        Verify_State === "Token_Irrelevant" ?
                                            "Account already verified"
                                            :
                                            Verify_State === "Token_Expired" ?
                                                "Verification link expired"
                                                :
                                                Verify_State === "Reverify_Sent" ?
                                                    "New verification link sent"
                                                    :
                                                    "Verify account"
                                }
                            </h2>
                            <p className='General_Paragraph'>
                                {Verify_State === "Token_Nothing" ?
                                    "Please go back to the register screen."
                                    :
                                    Verify_State === "Token_Invalid" ?
                                        "This verification link does not belong to any account in the system and is invalid. Please go back to the register screen."
                                        :
                                        Verify_State === "Token_Irrelevant" ?
                                            "The account associated with this verification link had already been verified. Please go back to the log in screen."
                                            :
                                            Verify_State === "Token_Expired" ?
                                                "This verification link had already expired. You can click the button below to resend a new link to your email."
                                                :
                                                Verify_State === "Reverify_Sent" ?
                                                    "A new verification link had been sent to your email. This link is now rendered invalid."
                                                    :
                                                    "Please wait."
                                }
                            </p>
                            <div
                                className='Landing_Form_Message'
                                id="Landing_Form_Message"
                                State={Verify_State_Message == "Active" ? "Active" : "Inactive"}
                                Indicator={Verify_State === "Verifying" ? "Neutral" : "Positive"}
                            >
                                <p className='Landing_Form_Message_Text' id='Landing_Form_Message_Text'>
                                    {Verify_State === "Verifying" ?
                                        "Contacting the server. This may take a minute."
                                        :
                                        ""
                                    }
                                </p>
                            </div>
                            {Verify_State !== "Verifying" ?
                                <>
                                    {Verify_State === "Token_Expired" ?
                                        <button type="submit" className="General_Button" Override_Form_Composition disabled={Loading == true ? true : false} style={{ marginTop: "10px" }} onClick={Resend}>
                                            Resend a new verification link
                                        </button>
                                        :
                                        ""
                                    }
                                    <button type="submit" className="General_Button" Override_Form_Composition disabled={Loading == true ? true : false} onClick={() => Navigate("/")}>
                                        Go back to login
                                    </button>
                                </>
                                :
                                ""
                            }

                        </div>

                    </div>
                    <div className="Landing_Logo_RED">
                        <img className="Landing_Logo_RED_Image" src={REDLogo} draggable="false" loading='lazy' alt='' />
                    </div>
                    <div className="Landing_Version">
                        <p className="Landing_Version_Text">

                        </p>
                    </div>
                </div>
                <div className="Landing_Banner">
                    <img className="Landing_Banner_Image" src={Background} draggable="false" loading='lazy' alt='' />
                </div>
            </div>
        </>

    )
}